// extracted by mini-css-extract-plugin
export default {"svmVsLivingOs":"_9pkKLOelRPecKIJ-cMXGsQ==","banner":"pPoMkG9H5Vg7jvSZcnsVow=="};